<template>
	<div>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<div v-if="!assurances.length">
				<h3 class="text-center red--text">تضمینی برای این وام ثبت نشده است</h3>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="green" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن تضمین
					</v-btn>
				</div>
			</div>
			<div v-else>
				<v-card v-for="(assurance, index) in assurances" :key="assurance.id + index" class="mb-8" elevation="5">
					<v-row class="d-flex">
						<v-col cols="12" md="3" class="pa-3 text-center">
							<ImageUploader :ref="'imageUploader' + assurance.id + index" :editable="!!assurance.editMode" v-model="assurance.base64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(assurance.base64)" @delete="() => assurance.fileName = ''" />
							<v-icon style="cursor: pointer;" class="mx-auto" @click="viewImage(assurance.base64)" v-if="!assurance.editMode" fab color="green">mdi-magnify-plus</v-icon>
						</v-col>
						<v-col cols="12" md="9">
							<v-card-text>
								<div v-if="!assurance.editMode" style="white-space: pre-line">
									{{ assurance.description }}
								</div>
								<div v-else>
									<v-textarea v-model="assurance.description" outlined :error-messages="errorMessages" label="شرح تضیمن" hint="حداکثر 1000 کاراکتر" />
								</div>
							</v-card-text>
						</v-col>
					</v-row>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn v-if="!assurance.editMode" @click="edit(assurance)" class="ms-2" small fab dark color="green" title="ویراش">
							<v-icon dark>
								mdi-square-edit-outline
							</v-icon>
						</v-btn>
						<v-btn v-if="!assurance.editMode" @click="remove(assurance, index)" class="ms-2" small fab dark color="pink" title="حذف">
							<v-icon dark>
								mdi-trash-can-outline
							</v-icon>
						</v-btn>
						<v-btn class="mx-1" @click="cancel(assurance, index)" v-if="assurance.editMode" color="grey" small dark>
							انصراف
						</v-btn>
						<v-btn :loading="submitLoading" @click="save(assurance, index)" v-if="assurance.editMode" color="blue" small dark>
							ذخیره
						</v-btn>
					</v-card-actions>
				</v-card>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="green" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن تضمین
					</v-btn>
				</div>
			</div>
		</div>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import ImageUploader from '@/components/uploader/ImageUploader'

	export default {
		name: 'Assurance',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ImageUploader,
		},
		data() {
			return {
				overlayImgSrc: '',
				overlay: false,
				errorMessages: '',
				assurances: [],
				localData: {},
				submitLoading: false,
				loading: false
			}
		},
		computed: {

		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/Assurance/ListByUserLoanId/' + this.data.id, null)
					.then(
						response => {
							this.assurances = response.map(x => {
								x.editMode = false
								return x
							})
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			edit(assurance) {
				assurance.editMode = true
				assurance.original = JSON.parse(JSON.stringify(assurance))
			},
			save(assurance, index) {
				if (!assurance.description) {
					toast.error('شرح تضمین را وارد کنید.')
					return
				}
				const formData = new FormData()
				var fileUploader = Array.isArray(this.$refs['imageUploader' + assurance.id + index]) ? this.$refs['imageUploader' + assurance.id + index][0] : null
				if (fileUploader && fileUploader.hasFile()) {
					formData.append('file', fileUploader.getFile())
				}
				formData.append('id', assurance.id)
				formData.append('description', assurance.description)
				formData.append('userLoanModel.id', this.data.id)
				formData.append('fileName', assurance.fileName)
				this.submitLoading = true
				api.post('admin/assurance/' + (assurance.id === emptyId ? 'create' : 'edit'), formData, { contentType: 'multipart/form-data' })
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						assurance.editMode = false
						if (assurance.id === emptyId) {
							if (fileUploader && fileUploader.hasFile()) {
								fileUploader.toBase64(fileUploader.getFile()).then(res => {
									assurance.base64 = res
									assurance.id = response
								})
							} else {
								assurance.id = response
							}
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			cancel(assurance, index) {
				if (assurance.id == emptyId) {
					this.assurances.splice(index, 1)
					return
				}
				assurance.description = assurance.original?.description
				assurance.editMode = false
			},
			async remove(assurance, index) {
				if (!assurance) {
					return
				}

				if (assurance.id == emptyId) {
					this.assurances.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این تضمین مطمئن هستید؟',
				)) {
					api.post('admin/assurance/delete/' + assurance.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.assurances.splice(index, 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			add() {
				let newAssurance = {
					id: emptyId,
					description: '',
					editMode: true
				}
				this.assurances.push(newAssurance)
			},
			viewImage(img) {
				this.overlay = true
				this.overlayImgSrc = img
			}
		},
	}
</script>
<style></style>
